import type {
    WorkloadFederationProvider,
    WorkloadFederationTrust,
} from 'pbts/c1/api/workload_federation/v1/workload_federation'
import {
    WorkloadFederationProviderRef,
    WorkloadFederationTrustRef,
} from 'pbts/c1/api/workload_federation/v1/workload_federation'
import { WorkloadFederationServiceClient } from 'pbts/c1/api/workload_federation/v1/workload_federation.client'
import { createMutationApi } from './lib/createMutationApi'
import { createPagedListApi } from './lib/createPagedListApi'
import { createUnaryApi } from './lib/createUnaryApi'

// Provider hooks

export const createProviderApi = createMutationApi(
    WorkloadFederationServiceClient,
    'createProvider',
    (r): WorkloadFederationProvider => r?.provider as WorkloadFederationProvider,
    WorkloadFederationProviderRef.typeName,
)

export const getProviderApi = createUnaryApi(
    WorkloadFederationServiceClient,
    'getProvider',
    (r): WorkloadFederationProvider => r?.provider as WorkloadFederationProvider,
    WorkloadFederationProviderRef.typeName,
)

export const updateProviderApi = createMutationApi(
    WorkloadFederationServiceClient,
    'updateProvider',
    (r): WorkloadFederationProvider => r?.provider as WorkloadFederationProvider,
    WorkloadFederationProviderRef.typeName,
)

export const deleteProviderApi = createMutationApi(
    WorkloadFederationServiceClient,
    'deleteProvider',
    undefined,
    WorkloadFederationProviderRef.typeName,
)

export const listProvidersApi = createPagedListApi(
    WorkloadFederationServiceClient,
    'listProviders',
    undefined,
    WorkloadFederationProviderRef.typeName,
)

// Trust hooks

export const createTrustApi = createMutationApi(
    WorkloadFederationServiceClient,
    'createTrust',
    (r): WorkloadFederationTrust => r?.trust as WorkloadFederationTrust,
    WorkloadFederationTrustRef.typeName,
)

export const listTrustsApi = createPagedListApi(
    WorkloadFederationServiceClient,
    'listTrusts',
    undefined,
    WorkloadFederationTrustRef.typeName,
)

export const updateTrustApi = createMutationApi(
    WorkloadFederationServiceClient,
    'updateTrust',
    (r): WorkloadFederationTrust => r?.trust as WorkloadFederationTrust,
    WorkloadFederationTrustRef.typeName,
)

export const deleteTrustApi = createMutationApi(
    WorkloadFederationServiceClient,
    'deleteTrust',
    undefined,
    WorkloadFederationTrustRef.typeName,
)

export const searchTrustsApi = createPagedListApi(
    WorkloadFederationServiceClient,
    'searchTrusts',
    undefined,
    WorkloadFederationTrustRef.typeName,
)

// Testing hooks

export const testTokenApi = createMutationApi(
    WorkloadFederationServiceClient,
    'testToken',
    undefined,
    WorkloadFederationTrustRef.typeName,
)

export const testCELApi = createMutationApi(
    WorkloadFederationServiceClient,
    'testCEL',
    undefined,
    undefined,
)
